import { get, post } from "@/shared/api/api-client";
import { injectable } from "inversify";
import { IRangeApiObject } from "../ts/logistics.types";

@injectable()
export class LogisticMixingService {
    getRanges(): Promise<IRangeApiObject[]> {
        return get(`${PUBLIC_API_URL}/distance_ranges`)
    }

    saveRanges(data: IRangeApiObject[]) {
        return post(`${PUBLIC_API_URL}/distance_ranges`, data as any)
    }
}